import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _assertThisInitialized from "/app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/app/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
// Copyright 2017-2022 @polkadot/types-codec authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { Int } from "../base/Int.js";
/**
 * @name i128
 * @description
 * A 128-bit signed integer
 */

export var i128 = /*#__PURE__*/function (_Int$with) {
  _inherits(i128, _Int$with);

  var _super = _createSuper(i128);

  function i128() {
    var _this;

    _classCallCheck(this, i128);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "__IntType", 'i128');

    return _this;
  }

  return _createClass(i128);
}(Int.with(128));